const middleware = {}

middleware['agency/favorites'] = require('../middleware/agency/favorites.js')
middleware['agency/favorites'] = middleware['agency/favorites'].default || middleware['agency/favorites']

middleware['agency/favorites/_id'] = require('../middleware/agency/favorites/_id.js')
middleware['agency/favorites/_id'] = middleware['agency/favorites/_id'].default || middleware['agency/favorites/_id']

middleware['band_select'] = require('../middleware/band_select.js')
middleware['band_select'] = middleware['band_select'].default || middleware['band_select']

middleware['band/dashboard'] = require('../middleware/band/dashboard.js')
middleware['band/dashboard'] = middleware['band/dashboard'].default || middleware['band/dashboard']

middleware['band/parameter'] = require('../middleware/band/parameter.js')
middleware['band/parameter'] = middleware['band/parameter'].default || middleware['band/parameter']

middleware['band/payin'] = require('../middleware/band/payin.js')
middleware['band/payin'] = middleware['band/payin'].default || middleware['band/payin']

middleware['band/profile'] = require('../middleware/band/profile.js')
middleware['band/profile'] = middleware['band/profile'].default || middleware['band/profile']

middleware['band/profile/_slug'] = require('../middleware/band/profile/_slug.js')
middleware['band/profile/_slug'] = middleware['band/profile/_slug'].default || middleware['band/profile/_slug']

middleware['band/profile/create'] = require('../middleware/band/profile/create.js')
middleware['band/profile/create'] = middleware['band/profile/create'].default || middleware['band/profile/create']

middleware['band/profile/delete'] = require('../middleware/band/profile/delete.js')
middleware['band/profile/delete'] = middleware['band/profile/delete'].default || middleware['band/profile/delete']

middleware['band/profile/edit'] = require('../middleware/band/profile/edit.js')
middleware['band/profile/edit'] = middleware['band/profile/edit'].default || middleware['band/profile/edit']

middleware['band/profile/select'] = require('../middleware/band/profile/select.js')
middleware['band/profile/select'] = middleware['band/profile/select'].default || middleware['band/profile/select']

middleware['band/recap'] = require('../middleware/band/recap.js')
middleware['band/recap'] = middleware['band/recap'].default || middleware['band/recap']

middleware['band/sendtrack'] = require('../middleware/band/sendtrack.js')
middleware['band/sendtrack'] = middleware['band/sendtrack'].default || middleware['band/sendtrack']

middleware['band/shop'] = require('../middleware/band/shop.js')
middleware['band/shop'] = middleware['band/shop'].default || middleware['band/shop']

middleware['draft'] = require('../middleware/draft.js')
middleware['draft'] = middleware['draft'].default || middleware['draft']

middleware['draft/favorites'] = require('../middleware/draft/favorites.js')
middleware['draft/favorites'] = middleware['draft/favorites'].default || middleware['draft/favorites']

middleware['draft/id'] = require('../middleware/draft/id.js')
middleware['draft/id'] = middleware['draft/id'].default || middleware['draft/id']

middleware['draft/influencers'] = require('../middleware/draft/influencers.js')
middleware['draft/influencers'] = middleware['draft/influencers'].default || middleware['draft/influencers']

middleware['i18n'] = require('../middleware/i18n.js')
middleware['i18n'] = middleware['i18n'].default || middleware['i18n']

middleware['i18n/cleanRoute'] = require('../middleware/i18n/cleanRoute.js')
middleware['i18n/cleanRoute'] = middleware['i18n/cleanRoute'].default || middleware['i18n/cleanRoute']

middleware['i18n/doubleSlashRemover'] = require('../middleware/i18n/doubleSlashRemover.js')
middleware['i18n/doubleSlashRemover'] = middleware['i18n/doubleSlashRemover'].default || middleware['i18n/doubleSlashRemover']

middleware['i18n/loggedIn'] = require('../middleware/i18n/loggedIn.js')
middleware['i18n/loggedIn'] = middleware['i18n/loggedIn'].default || middleware['i18n/loggedIn']

middleware['i18n/pathCleaner'] = require('../middleware/i18n/pathCleaner.js')
middleware['i18n/pathCleaner'] = middleware['i18n/pathCleaner'].default || middleware['i18n/pathCleaner']

middleware['i18n/slashAdder'] = require('../middleware/i18n/slashAdder.js')
middleware['i18n/slashAdder'] = middleware['i18n/slashAdder'].default || middleware['i18n/slashAdder']

middleware['index'] = require('../middleware/index.js')
middleware['index'] = middleware['index'].default || middleware['index']

middleware['influencer_dashboard'] = require('../middleware/influencer_dashboard.js')
middleware['influencer_dashboard'] = middleware['influencer_dashboard'].default || middleware['influencer_dashboard']

middleware['influencer/activate'] = require('../middleware/influencer/activate.js')
middleware['influencer/activate'] = middleware['influencer/activate'].default || middleware['influencer/activate']

middleware['influencer/parameter'] = require('../middleware/influencer/parameter.js')
middleware['influencer/parameter'] = middleware['influencer/parameter'].default || middleware['influencer/parameter']

middleware['influencer/profile'] = require('../middleware/influencer/profile.js')
middleware['influencer/profile'] = middleware['influencer/profile'].default || middleware['influencer/profile']

middleware['influencer/profile/_slug'] = require('../middleware/influencer/profile/_slug.js')
middleware['influencer/profile/_slug'] = middleware['influencer/profile/_slug'].default || middleware['influencer/profile/_slug']

middleware['influencer/profile/edit'] = require('../middleware/influencer/profile/edit.js')
middleware['influencer/profile/edit'] = middleware['influencer/profile/edit'].default || middleware['influencer/profile/edit']

middleware['influencerFetch'] = require('../middleware/influencerFetch.ts')
middleware['influencerFetch'] = middleware['influencerFetch'].default || middleware['influencerFetch']

middleware['parameter'] = require('../middleware/parameter.js')
middleware['parameter'] = middleware['parameter'].default || middleware['parameter']

middleware['payin/failure'] = require('../middleware/payin/failure.js')
middleware['payin/failure'] = middleware['payin/failure'].default || middleware['payin/failure']

middleware['previous_url'] = require('../middleware/previous_url.js')
middleware['previous_url'] = middleware['previous_url'].default || middleware['previous_url']

middleware['reset_draft'] = require('../middleware/reset_draft.js')
middleware['reset_draft'] = middleware['reset_draft'].default || middleware['reset_draft']

middleware['reset-password'] = require('../middleware/reset-password.js')
middleware['reset-password'] = middleware['reset-password'].default || middleware['reset-password']

middleware['utm'] = require('../middleware/utm.js')
middleware['utm'] = middleware['utm'].default || middleware['utm']

middleware['welcome'] = require('../middleware/welcome.js')
middleware['welcome'] = middleware['welcome'].default || middleware['welcome']

export default middleware
